<div class="user" *ngIf="username && loggedIn">
    <span class="welcome" [ngClass]="{'tooltip': !!userToolTip}">Welcome {{username}}
        <span *ngIf="userToolTip" class="tooltip-text">{{userToolTip}}</span>
    </span>
    <span class="logout" (click)="logout()">Logout</span>
</div>
